import type * as THREE from "three";
import { createToken, type EventDispatcher, type IService } from "@designboticteam/core";

interface ICameraControlService extends IService {
	readonly onCameraUpdated: EventDispatcher<{ camera: THREE.PerspectiveCamera }>;
	readonly onCameraControlsStatusChanged: EventDispatcher<{ isEnabled: boolean }>;

	enable(): void;
	disable(): void;

	get targetPoint(): THREE.Vector3;
	setTargetPoint(target: THREE.Vector3): void;
}

const CAMERA_CONTROL_SERVICE = createToken<ICameraControlService>("ICameraControlService");

export { CAMERA_CONTROL_SERVICE, type ICameraControlService };
